import { TattooCategory } from '~/shared';
import { IListItem } from '../../components/ListTab';
import { createSlice } from '../wrappers';

export enum StageTypes {
	Category = 'category',
	List = 'list',
}

interface TattooShopSlice {
	activeStage: StageTypes;
	activeCategory: TattooCategory | null | 'delete';
	activeList: IListItem[];
	activeListIndex: number | null;
	maxListIndex: number;
}

const initialState: TattooShopSlice = {
	activeStage: StageTypes.Category,
	activeCategory: null,
	activeList: [] as IListItem[],
	activeListIndex: null,
	maxListIndex: 0,
};

const tattooShopSlice = createSlice({
	name: 'tattooShop',
	initialState,
	reducers: {
		setActiveStage: (state, action) => {
			state.activeStage = action.payload;
		},
		setActiveCategory: (state, action) => {
			state.activeCategory = action.payload;
		},
		setActiveListIndex: (state, action) => {
			state.activeListIndex = action.payload;
		},
		setMaxListIndex: (state, action) => {
			state.maxListIndex = action.payload;
		},
		setActiveList: (state, action) => {
			state.activeList = action.payload;
		},
	},
});

export const {
	setActiveStage,
	setActiveCategory,
	setActiveListIndex,
	setMaxListIndex,
	setActiveList,
} = tattooShopSlice.actions;

export default tattooShopSlice.reducer;
